import { guestAppConfig } from '@tov-plus/config';
import { TovButton, msg, TovCard } from '@tov-plus/ui';
import { useEffect, useState } from 'react';
import { NavLink } from '@tov-plus/frontend-data';

import { formatGuestDateTime } from '../lib/localization/guestLocale';
import {
  parseRecentGuestAccessEntries,
  recentGuestAccessStorageKey,
  type RecentGuestAccessEntry,
} from '../lib/storage/recentGuestAccess';

export function RecentInvitesPage() {
  const [recentInvites, setRecentInvites] = useState<RecentGuestAccessEntry[]>(
    [],
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      setRecentInvites(
        parseRecentGuestAccessEntries(
          window.localStorage.getItem(recentGuestAccessStorageKey),
        ),
      );
    } catch {
      setRecentInvites([]);
    }
  }, []);

  return (
    <div className="page-grid">
      <TovCard variant="content" isWide className="hero-card">
        <p className="page-eyebrow">
          {msg(
            'pages.recent_invites_page.pages_recent_invites_page_returning_guests',
          )}
        </p>
        <h2>
          {msg(
            'pages.recent_invites_page.pages_recent_invites_page_resume_the_right_occasion',
          )}
        </h2>
        <p>
          {msg(
            'pages.recent_invites_page.pages_recent_invites_page_tov_keeps_recent_invite_continuity_on_this_device',
          )}{' '}
        </p>
        <div className="action-row">
          <TovButton asChild>
            <NavLink to="/my-invite">
              {msg(
                'pages.recent_invites_page.pages_recent_invites_page_open_current_invite',
              )}
            </NavLink>
          </TovButton>
          <TovButton asChild variant="secondary">
            <NavLink to="/access">
              {msg('app.guest_workflows.access_details')}
            </NavLink>
          </TovButton>
          <TovButton asChild variant="secondary">
            <a
              href={`mailto:${guestAppConfig.supportEmail}?subject=Recent%20invite%20recovery`}
            >
              {msg('app.router.app_router_contact_support')}{' '}
            </a>
          </TovButton>
        </div>
      </TovCard>

      <TovCard variant="content" isWide>
        <p className="page-eyebrow">
          {msg(
            'pages.recent_invites_page.pages_recent_invites_page_recent_invite_history',
          )}
        </p>
        {recentInvites.length > 0 ? (
          <div className="detail-list detail-list--stacked">
            {recentInvites.map((item) => (
              <article
                key={`recent-invite:${item.occasionSlug}:${item.seenAt}`}
              >
                <strong>{item.occasionDisplayName}</strong>
                <span>
                  {item.guestDisplayName}{' '}
                  {msg('pages.access_page.pages_access_page_last_opened')}{' '}
                  {formatGuestDateTime(
                    item.seenAt,
                    item.localeCode,
                    item.timezone,
                  )}
                </span>
                <span>
                  {item.resumePath
                    ? `Last saved route: ${item.resumePath}`
                    : msg(
                        'pages.recent_invites_page.pages_recent_invites_page_no_route_snapshot_was_saved_for_this_invite',
                      )}
                </span>
                <span>
                  {msg(
                    'pages.recent_invites_page.pages_recent_invites_page_guest_access_is_still_token_first_so_reopen',
                  )}{' '}
                </span>
                <span>
                  {msg(
                    'pages.recent_invites_page.pages_recent_invites_page_secure_continuity_packet_occasion_slug',
                  )}{' '}
                  {item.occasionSlug}{' '}
                  {msg(
                    'pages.recent_invites_page.pages_recent_invites_page_last_route',
                  )}{' '}
                  {item.resumePath ?? '/'}.
                </span>
              </article>
            ))}
          </div>
        ) : (
          <p>
            {msg(
              'pages.recent_invites_page.pages_recent_invites_page_no_recent_invite_history_is_stored_on_this',
            )}{' '}
          </p>
        )}
      </TovCard>
    </div>
  );
}
